import { getDomainExtension } from '@utils/getDomainExtension'
import { landingPagesData } from './landingPagesData'

export const allLandingPageRoutes = () => {
    const domain = getDomainExtension()

    return landingPagesData.map((route) => {
        switch (domain) {
            case 'de':
            case 'ch':
            case 'at': {
                return {
                    originalPath: route.routeDE,
                    redirectPath: route.routeEN,
                    key: route.key
                }
            }
            default: {
                return {
                    originalPath: route.routeEN,
                    redirectPath: route.routeDE,
                    key: route.key
                }
            }
        }
    })
}
